import { render, staticRenderFns } from "./TC.vue?vue&type=template&id=591fd80c"
import script from "./TC.vue?vue&type=script&scoped=true&lang=js"
export * from "./TC.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./TC.vue?vue&type=style&index=0&id=591fd80c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports